// The app's store listings, and which one a visitor's own phone uses.
//
// One place for the two URLs, because they now appear on /mobile AND in the
// download popup on /umanitoba, and a listing id that drifts between the two
// is a button that opens the wrong page on exactly one of them. The same two
// URLs are in UMapsMobile's `src/betaSunset/policy.ts`.

/** The live store listings. */
export const APP_STORE_URL = 'https://apps.apple.com/ca/app/umaps-umanitoba/id6807111803';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.myumaps.app&pcampaignid=web_share';
/**
 * Play's opt-out page for the closed test. ⚠️ On Android this is the step that
 * matters for a former beta tester: still enrolled, a reinstall from the
 * listing is served the highest version code their tracks offer, which is
 * the beta again.
 */
export const PLAY_LEAVE_BETA_URL = 'https://play.google.com/apps/testing/com.myumaps.app';

/**
 * Which store this visitor's own phone uses — 'ios', 'android' or null.
 *
 * Read from the user agent, and used for ORDER and emphasis only: both
 * buttons are always there, because a phone is not the only thing that opens
 * these pages (a parent on a laptop, a poster QR scanned by a tablet). iPadOS
 * reports itself as a Mac, so a touch-capable "Mac" is an iPad.
 */
export function detectOs(nav = typeof navigator !== 'undefined' ? navigator : {}) {
  const ua = String(nav.userAgent || '');
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Macintosh/i.test(ua) && Number(nav.maxTouchPoints) > 1) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return null;
}
